// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1j0XS","item":"PaymentsMobile_item__2s6dj","label":"PaymentsMobile_label__1YP3O","amount":"PaymentsMobile_amount__3UwU9"};